// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // 👈 Add this
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyChse37kTI1WJIzSj_atDxBuNNzlnJ8w4A",
  authDomain: "staco-285ed.firebaseapp.com",
  projectId: "staco-285ed",
  storageBucket: "staco-285ed.firebasestorage.app",
  messagingSenderId: "186441602598",
  appId: "1:186441602598:web:27d59075762418827378e7",
  measurementId: "G-0TN3NBBCHM"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app); 
const analytics = getAnalytics(app);

export { auth, db }; 
export const storage = getStorage(app);